<template lang="pug">
.m-card
  .m-card-header(:id="'heading-wm-' + id" :data-bs-target="'#collapse-wm-' + id" :aria-controls="'collapse-wm-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_WM", 1) }}
  .m-card-body.collapse.show(:id="'collapse-wm-' + id" :aria-labelledby="'heading-wm-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T  
          .odds-group
            .col
              template(v-for="item in col1")
                template(v-if="moreItems['wmo'][item] && moreItems['wmo'][item][5] != 0 && moreItems['wmo'][item][5] != ''")
                  OddsItem(:odds="moreItems['wmo'][item]" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BK_' + item)")
                template(v-else)
                  OddsDisabled
            .col
              template(v-for="item in col2")
                template(v-if="moreItems['wmo'][item] && moreItems['wmo'][item][5] != 0 && moreItems['wmo'][item][5] != ''")
                  OddsItem(:odds="moreItems['wmo'][item]" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BK_' + item)")
                template(v-else)
                  OddsDisabled

                  
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-wm-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-wm-' + id"
//-     :aria-controls="'collapse-wm-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_WM") }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-wm-' + id"
//-     :id="'collapse-wm-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group(v-for="item in col1")
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BK_" + item) }}
//-               template(v-if="moreItems['wmo'][item] && moreItems['wmo'][item][5] != 0 && moreItems['wmo'][item][5] != ''")
//-                 OddsItem(:odds="moreItems['wmo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="wmo")
//-               template(v-else)
//-                 OddsDisabled
//-           .normal-odd-area
//-             .normal-odd-area-group(v-for="item in col2")
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BK_" + item) }}
//-               template(v-if="moreItems['wmo'][item] && moreItems['wmo'][item][5] != 0 && moreItems['wmo'][item][5] != ''")
//-                 OddsItem(:odds="moreItems['wmo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="wmo")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col1: ["H1", "H2", "H3Up", "D"],
      col2: ["A1", "A2", "A3Up", "NG"],
    }
  }
}
</script>
